import { useQuery } from "@tanstack/react-query";
import ConfigHolder from "../../config/ConfigHolder";
import useWidgetStore from "../../store/useWidgetStore";
import { useSettings } from "../../context/SettingsContext";
/**
 * The subscriptions the signed in consumer holds with this company.
 *
 * This is the consumer's own subscription list (/consumer/subscription/list) in the widget. Not
 * to be confused with `useSubscriptions`, which asks what the consumer could buy or pay this
 * booking with; this one is what they already have, usable ones first, each carrying whether it
 * can still be booked with and - when it cannot - why not.
 *
 * The consumer is the one in the store, sent as the token the sign in returned. Without a signed
 * in consumer there is nothing to ask for, so the query does not run.
 */
export const useConsumerSubscriptions = (options) => {
    const { api_key, widget_id } = useSettings();
    const { consumer } = useWidgetStore();
    const defaultOptions = Object.assign(Object.assign({}, options), { enabled: !!(consumer === null || consumer === void 0 ? void 0 : consumer.id), networkMode: "always", cacheTime: 0, staleTime: 0 });
    return useQuery(Object.assign(Object.assign({}, defaultOptions), { queryKey: ['widget-consumer-subscriptions', consumer === null || consumer === void 0 ? void 0 : consumer.id], queryFn: async ({ signal }) => {
            var _a;
            let url = ConfigHolder.getApiMethodUrl(api_key, widget_id, 'subscriptions', 'consumer');
            let data = {
                consumerId: (_a = consumer === null || consumer === void 0 ? void 0 : consumer.id) !== null && _a !== void 0 ? _a : ''
            };
            const response = await fetch(url.href, {
                signal: signal,
                method: "POST",
                headers: {
                    'Content-Type': 'application/json', // checks this header if it's a POST, while calling the method getRestData.... That's not Restful
                    'X-OAnl-csrf-protection': 'on',
                    'accept': 'application/json+ld',
                },
                body: JSON.stringify(data)
            });
            return response.json();
        } }));
};
